import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'profile/single-day-graf-modal';

export const SINGLE_DAY_GRAF_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const singleDayGrafModalActions = {
  open: createAction(SINGLE_DAY_GRAF_MODAL.OPEN),
  close: createAction(SINGLE_DAY_GRAF_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  type: 'steps',
  baseDate: '',
  entity: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SINGLE_DAY_GRAF_MODAL.OPEN: {
      return {
        ...state,
        opened: true,
        baseDate: payload.baseDate,
        type: payload.type,
        entity: payload.entity,
      };
    }

    case SINGLE_DAY_GRAF_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/single-day-graf-modal.js